import {IServicesCategory, IServicesCategoryListItem, ServicesCategoryResponseType} from "@/entity/servicesCategory/services.category.types";

export default class ServicesCategory implements IServicesCategory {
    total: number;
    data: IServicesCategoryListItem[] = [];
    constructor(data: ServicesCategoryResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}